const CLIENT_DEMOGRAPHICS_FIELD_ORDER = [
  "address",
  "date_of_birth",
  "email",
  "phone",
  "date_of_accident",
  "incident_location",
  "incident_city",
  "incident_state",
];

const CLIENT_DEMOGRAPHICS_FIELD_SPANS = {
  address: "md:col-span-6",
  date_of_birth: "md:col-span-6",
  email: "md:col-span-6",
  phone: "md:col-span-6",
  date_of_accident: "md:col-span-4",
  incident_location: "md:col-span-4",
  incident_city: "md:col-span-4",
  incident_state: "md:col-span-4",
};

export const orderFieldsForClientDemographics = (fields = []) => {
  const preferred = CLIENT_DEMOGRAPHICS_FIELD_ORDER.filter((field) => fields.includes(field));
  const remaining = fields.filter((field) => !CLIENT_DEMOGRAPHICS_FIELD_ORDER.includes(field));
  return [...preferred, ...remaining];
};

export const getSpanClassForClientDemographics = (fieldName, fallback) =>
  CLIENT_DEMOGRAPHICS_FIELD_SPANS[fieldName] || fallback;
